
import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-slate-900 text-white py-16">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <h3 className="text-2xl font-bold">GET GERAGHTY</h3>
            <p className="text-slate-300 leading-relaxed">
              Where Alexis "Lexi" Geraghty is looking for her next great connection. One application. One chance to impress her.
            </p>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Quick Links</h4>
            <div className="space-y-2">
              <button 
                onClick={() => document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-slate-300 hover:text-white transition-colors cursor-pointer"
              >
                Meet Lexi
              </button>
              <button 
                onClick={() => document.getElementById('application')?.scrollIntoView({ behavior: 'smooth' })}
                className="block text-slate-300 hover:text-white transition-colors cursor-pointer"
              >
                Apply Now
              </button>
              <a 
                href="mailto:hello@getgeraghty.com" 
                className="block text-slate-300 hover:text-white transition-colors"
              >
                Contact
              </a>
            </div>
          </div>

          {/* Share */}
          <div className="space-y-4">
            <h4 className="text-lg font-semibold">Know Someone Perfect for Lexi?</h4>
            <p className="text-slate-300 text-sm mb-4">
              Share this opportunity with someone who fits what she's looking for
            </p>
            <div className="flex space-x-4">
              <button className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-slate-700 transition-colors">
                <i className="ri-twitter-line text-lg"></i>
              </button>
              <button className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-slate-700 transition-colors">
                <i className="ri-linkedin-line text-lg"></i>
              </button>
              <button className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-slate-700 transition-colors">
                <i className="ri-facebook-line text-lg"></i>
              </button>
              <button className="w-10 h-10 bg-slate-800 rounded-lg flex items-center justify-center hover:bg-slate-700 transition-colors">
                <i className="ri-share-line text-lg"></i>
              </button>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-slate-400 text-sm">
              © 2024 Get Geraghty. All rights reserved.
            </div>
            <div className="flex items-center space-x-6">
              <a 
                href="mailto:hello@getgeraghty.com" 
                className="text-slate-400 hover:text-white text-sm transition-colors"
              >
                hello@getgeraghty.com
              </a>
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white text-sm transition-colors"
              >
                Website Builder
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
